import { render } from "./Register.vue?vue&type=template&id=70b225b5&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=70b225b5&scoped=true&lang=css"

import exportComponent from "D:\\图书管理系统VUE\\Vue-Springboot-Library\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b225b5"]])

export default __exports__